<div class="modal-header">
  <h4 class="modal-title">{{ modalTitle }}</h4>
  <button type="button" class="btn-close no-outline" aria-label="close" (click)="modal.dismiss()">
  </button>
</div>
<div class="modal-body pb-4">
  <form [formGroup]="searchForm" class="inputGroup">
    <input type="search" class="form-control no-outline mb-3" formControlName="search"
      placeholder="{{ 'search' | label: 'general' | async }}" />
    <span class="highlight"></span>
    <span class="bar"></span>
  </form>
  <div class="table-responsive shadow">
    <table class="table table-details table-details--small">
      <thead>
        <tr>
          <th width="50"></th>
          <th *ngFor="let property of displayProperties">
            {{ property.display }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="cursor-pointer" *ngFor="let item of viewList; let i = index" (click)="selectItem(i)">
          <td *ngIf="!multiSelect" class="pt-2">
            <input type="radio" [checked]="item.selected" />
          </td>
          <td *ngIf="multiSelect" class="pt-2">
            <input type="checkbox" [checked]="item.selected" />
          </td>
          <td *ngFor="let property of displayProperties" [ngClass]="property.classes">
            {{ getDisplayValue(item, property.property) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-center mt-4">
    <ngb-pagination [(page)]="pagingState.page" [pageSize]="pagingState.pageSize" [collectionSize]="count"
      (pageChange)="changePage($event)"></ngb-pagination>
  </div>

  <button type="button" class="btn" (click)="confirmSelection()">
    {{ 'confirm' | label: 'general' | async }}
  </button>
</div>